import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  // Three themes: 'light', 'dark', 'glass'. Default to 'dark' (the app's signature
  // look); Light is a fully-supported option users can pick in Settings.
  const [theme, setTheme] = useState(() => localStorage.getItem('veonfox_theme') || 'dark');

  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
    root.classList.remove('glass-theme');

    if (theme === 'dark') {
      root.classList.add('dark');
    } else if (theme === 'glass') {
      root.classList.add('dark');
      root.classList.add('glass-theme');
    }
    // 'light' → no class (default Tailwind light utilities apply)
    localStorage.setItem('veonfox_theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => {
      if (prev === 'light') return 'dark';
      if (prev === 'dark') return 'glass';
      return 'light';
    });
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
